import { render } from "./MonsterItemInformation.vue?vue&type=template&id=6a9777c4"
import script from "./MonsterItemInformation.vue?vue&type=script&lang=js"
export * from "./MonsterItemInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__